import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useRouteLoaderData } from "react-router-dom";

import { useAppApi } from "@/App";
import { DeveloperResidenceTerr, DeveloperState } from "@/const";
import { DevForm, FormFieldGroup } from "@components/Forms/Fields";
import { useSubmit } from "@components/Forms/Handlers";
import { Awesome, DevModal } from "@components/Helpers";
import { CommonCard } from "@components/Pages";
import { FindDuplsPublisherModal, doFindDuplsPublisher } from "@components/PublisherDuplicates";
import { url_reverse } from "@components/Utils";

export default function AppForm({ developerId, header }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:developer:app_form", { developer_id: developerId }));
    const developerCommonInfo = useRouteLoaderData("developerCommonInfo");
    const onFormSubmit = useSubmit();
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [showChatMaxModal, setShowChatMaxModal] = useState(false);
    const [matchData, setMatchData] = useState(null);

    if (!apiData) return;

    const closeChatMaxModal = () => {
        setShowChatMaxModal(false);
    };

    const beforeSubmitHandle = (ev) => {
        ev.preventDefault();
        if (
            developerCommonInfo.developer.residence_terr === DeveloperResidenceTerr.VKP_OTHER &&
            !apiData.forms_data.main.data.chat_max_url
        ) {
            setShowChatMaxModal(true);
        } else {
            onFormSubmit(ev);
        }
    };

    return (
        <CommonCard header={header}>
            <Form>
                <DevForm.Field
                    prefix="main"
                    name="name"
                    append={
                        <Awesome
                            type="search-plus"
                            tooltip={t("Поиск совпадений")}
                            onClick={() => doFindDuplsPublisher(apiData.forms_data.main.data.name, setMatchData)}
                        />
                    }
                />
                <DevForm.Field prefix="main" name="residence_terr" />
                <DevForm.Field prefix="main" name="contact_phone" />
                <DevForm.Field prefix="main" name="contact_email" />
                {["telegram"].map((k) => {
                    const val = developerCommonInfo.developer.info[k];
                    if (!val) {
                        return null;
                    }
                    return (
                        <FormFieldGroup key={k} label={k}>
                            <DevForm.TextInput value={val} disabled />
                        </FormFieldGroup>
                    );
                })}
                <DevForm.Field prefix="main" name="about_game" />
                <DevForm.Field prefix="main" name="company_ru" />
                <DevForm.Field prefix="main" name="country" />
                <hr />
                <DevForm.Field
                    prefix="main"
                    name="chat_max_url"
                    append={
                        <>
                            <Awesome
                                type="clipboard"
                                onClick={() => navigator.clipboard.writeText(apiData.forms_data.main.data.chat_max_url)}
                            />
                            <span style={{ width: "20px", color: "#c0bdbd" }}>|</span>
                            <Awesome
                                type="external-link"
                                onClick={() =>
                                    window.open(apiData.forms_data.main.data.chat_max_url, "_blank", "noopener")
                                }
                            />
                        </>
                    }
                />
                <DevForm.Field prefix="main" name="allow_repeated_registration" />
                {(developerCommonInfo.developer.state === DeveloperState.REJECTED ||
                    developerCommonInfo.developer.state === DeveloperState.NEW) && (
                    <DevForm.Button
                        variant="success"
                        type="submit"
                        name="action"
                        value="approve"
                        onClick={beforeSubmitHandle}
                    >
                        {t("Одобрить")}
                    </DevForm.Button>
                )}{" "}
                {(developerCommonInfo.developer.state === DeveloperState.APPROVED ||
                    developerCommonInfo.developer.state === DeveloperState.NEW) && (
                    <DevForm.Button variant="danger" name="reject" onClick={() => setShowRejectModal(true)}>
                        {t("Отклонить")}
                    </DevForm.Button>
                )}
            </Form>
            <DevModal
                size="lg"
                show={showRejectModal}
                onHide={() => setShowRejectModal(false)}
                header={t("Комментарии")}
                body={
                    <>
                        <DevForm.Field prefix="main" name="moderator_comment" />
                        <DevForm.Field prefix="main" name="service_comment" />
                    </>
                }
                footer={
                    <DevForm.Button
                        variant="primary"
                        type="submit"
                        name="action"
                        value="reject"
                        onClick={(ev) => onFormSubmit(ev, { onOK: () => setShowRejectModal(false) })}
                    >
                        {t("Применить")}
                    </DevForm.Button>
                }
            />
            <FindDuplsPublisherModal data={matchData} setData={setMatchData} />
            <DevModal
                size="lg"
                show={showChatMaxModal}
                onHide={closeChatMaxModal}
                header={t("Одобрить заявку без ссылки на чат MAX?")}
                body={t("Разработчик относится к территории резидентсва OTHER VK Play.")}
                footer={
                    <DevForm.Button
                        variant="primary"
                        type="submit"
                        name="action"
                        value="approve"
                        onClick={(ev) => {
                            closeChatMaxModal();
                            onFormSubmit(ev);
                        }}
                    >
                        {t("Да")}
                    </DevForm.Button>
                }
            />
        </CommonCard>
    );
}
